import { injectIntl } from 'react-intl';

import ServiceTreeView from './ServiceTreeView';

export default injectIntl(ServiceTreeView);
